module.exports = __webpack_public_path__ + "img/20220116_161306.27442e20.jpg";